<template>
  <div class="intake-content">
    <div v-if="selectedAddress">
      <div class="form-group" :id="`addressess-${selectedAddressIndex}-type-address-wrapper`">
        <label :for="`addressess-${selectedAddressIndex}-type-address`">
          Type woning
          <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
        </label>

        <div class="custom-select">
          <select
            :id="`addressess-${selectedAddressIndex}-type-address`"
            :value="selectedAddress.type_address"
            @change="(e) => updateAddressField([
              selectedAddress,
              'type_address',
              e.target.value
            ])"
          >
            <option value="">Selecteer een type woning</option>
            <option value="tussenwoning">Tussenwoning</option>
            <option value="hoek">Hoek</option>
            <option value="vrijstaand">Vrijstaand</option>
            <option value="appartement">Appartement</option>
            <option value="recreatie">Recreatie</option>
            <option value="anders">Anders</option>
          </select>
        </div>
      </div>

      <div class="row row--tight-gutters">
        <div class="col-md-6">
          <div class="form-group" :id="`addresses-${selectedAddressIndex}-street-wrapper`">
            <label :for="`addresses-${selectedAddressIndex}-street`">
              Straat
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              class="form-control"
              type="text"
              :id="`addresses-${selectedAddressIndex}-street`"
              :value="selectedAddress.street"
              @input="(e) => updateAddressField([selectedAddress, 'street', e.target.value])"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group" :id="`addressess-${selectedAddressIndex}-house-number-wrapper`">
            <label :for="`addressess-${selectedAddressIndex}-house-number`">
              Huisnummer
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              class="form-control"
              type="text"
              :id="`addressess-${selectedAddressIndex}-house-number`"
              :value="selectedAddress.house_number"
              @input="(e) => updateAddressField([selectedAddress, 'house_number', e.target.value])"
            />
          </div>
        </div>
      </div>

      <div class="row row--tight-gutters">
        <div class="col-md-6">
          <div class="form-group" :id="`addressess-${selectedAddressIndex}-postal-code-wrapper`">
            <label :for="`addressess-${selectedAddressIndex}-postal-code`">
              Postcode
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              class="form-control"
              type="text"
              :id="`addressess-${selectedAddressIndex}-postal-code`"
              :value="selectedAddress.postal_code"
              @input="(e) => updateAddressField([selectedAddress, 'postal_code', e.target.value])"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group" :id="`addressess-${selectedAddressIndex}-city-wrapper`">
            <label :for="`addressess-${selectedAddressIndex}-city`">
              Plaats
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              class="form-control"
              type="text"
              :id="`addressess-${selectedAddressIndex}-city`"
              :value="selectedAddress.city"
              @input="(e) => updateAddressField([selectedAddress, 'city', e.target.value])"
            />
          </div>
        </div>
      </div>

      <div class="form-group" :id="`addressess-${selectedAddressIndex}-country-wrapper`">
        <label :for="`addressess-${selectedAddressIndex}-country`">
          Land
          <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
        </label>

        <div class="custom-select">
          <select
            :id="`addressess-${selectedAddressIndex}-country`"
            :value="selectedCountry"
            @change="(e) => updateAddressField([selectedAddress, 'country', e.target.value])"
          >
            <option value="nl">Nederland</option>
            <option value="be">België</option>
            <option value="de">Duitsland</option>
          </select>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn--sm"
          @click="() => removeAddress(selectedAddressIndex)"
        >
          Verwijder adres
        </button>
      </div>
    </div>

    <div class="my-auto font-weight-bold text-center lg-font-size-lg" v-else>
      Er zijn nog geen adressen
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      selectedAddress: 'address/selectedAddress',
      selectedAddressIndex: 'address/selectedAddressIndex',
    }),

    selectedCountry() {
      if (typeof this.selectedAddress.country === 'undefined' || this.selectedAddress.country === '') {
        return 'nl';
      }

      return this.selectedAddress.country;
    },
  },

  methods: {
    ...mapMutations({
      updateAddressField: 'address/updateAddressField',
      removeAddress: 'address/removeAddress',
    }),
  },
};
</script>
